var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.88388 5.11612C6.39573 4.62796 5.60427 4.62796 5.11612 5.11612C4.62796 5.60427 4.62796 6.39573 5.11612 6.88388L10.2322 12L5.11612 17.1161C4.62796 17.6043 4.62796 18.3957 5.11612 18.8839C5.60427 19.372 6.39573 19.372 6.88388 18.8839L12 13.7678L17.1161 18.8839C17.6043 19.372 18.3957 19.372 18.8839 18.8839C19.372 18.3957 19.372 17.6043 18.8839 17.1161L13.7678 12L18.8839 6.88388C19.372 6.39573 19.372 5.60427 18.8839 5.11612C18.3957 4.62796 17.6043 4.62796 17.1161 5.11612L12 10.2322L6.88388 5.11612Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.1df1ddf4b7b9479a052aad5768fc0ce4.svg";
export { ForwardRef as ReactComponent };